// Human-friendly countdown to a future ISO timestamp.
//   ≥ 1 day  → "6d 16h"
//   ≥ 1 hour → "16h 45m"
//   else     → "45m"
// Returns null once the target has passed.
export function formatCountdown(targetIso: string, now: number = Date.now()): string | null {
  const diff = new Date(targetIso).getTime() - now
  if (diff <= 0) return null

  const totalMinutes = Math.floor(diff / 60_000)
  const hours        = Math.floor(totalMinutes / 60)
  const minutes      = totalMinutes % 60
  const days         = Math.floor(hours / 24)

  if (days > 0)  return `${days}d ${hours % 24}h`
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m`
}
